var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMomentW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-794 -560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8455 10.9792 4.38715 10.9792 4.38715 4.52083 5.03298 4.52083 5.03298 9.58675C5.03298 9.58836 5.03427 9.58966 5.03589 9.58966 5.0375 9.58966 5.03879 9.58836 5.03879 9.58675 8.30561 4.05971 15.4344 2.22741 20.9615 5.49423 26.4886 8.76105 28.3208 15.8899 25.054 21.4169 21.7872 26.944 14.6583 28.7763 9.13131 25.5094 8.38954 25.071 7.69882 24.5515 7.07187 23.9604L7.51492 23.4906C11.927 27.6521 18.8773 27.449 23.0388 23.0369 27.2004 18.6248 26.9972 11.6745 22.5851 7.51298 18.173 3.35146 11.2227 3.55457 7.06122 7.96668 6.3932 8.6749 5.82235 9.46879 5.36365 10.3275 5.36274 10.3291 5.36329 10.331 5.36481 10.3319 5.36536 10.3322 5.36594 10.3324 5.36655 10.3324L10.8455 10.3324Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333,
    transform: "matrix(1.03226 0 0 1 794 560)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomentW);
export default __webpack_public_path__ + "static/media/moment-w.8546cf35490bc8ecce8054280434641d.svg";
export { ForwardRef as ReactComponent };